import React, { useState } from "react";
import "./Companylanding.css";

const Companylanding = (props) => {
  const [cbph, setHoverBP] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className="company_landing_page">
      <div className="cl_header">
        <div className="cl_header_logo">Virtual Physical Therapy. Reimagined.</div>
      </div>
      {/* --- */}
      <div className="cl_page">
        <div class="cl_round_block cl_round_block_green">
          <div className="cl_image_block">
            <div className="cl_ib_text">
              <div className="cl_ib_largetext">
                Feel Better from Home!
                <br />
                <span>No Cost. Just 20 Minutes a Day.</span>
              </div>
              <div className="cl_ib_smalltext">
                Start relieving pain and improving movement with expert-guided
                care.
              </div>
              <div
                className="cl_button_join cl_mobile_small"
                onClick={() => {
                  setIsPopupOpen(true);
                }}
              >
                Start Your Recovery Now, <span>At No Cost to You</span>
              </div>
            </div>
            <div className="cl_ib_image">
              <div className="cl_ib_img_virdio_laptopt">&nbsp;</div>
            </div>
          </div>
        </div>
        {/* --- */}
        <div className="cl_simple_block">
          <div className="cl_ib_semilargetext">
            Virtual Physical Therapy. Reimagined.
          </div>
          <div className="cl_ib_smalltext">
            Let Virdio Health help you reduce pain and get back to moving—on
            your terms, from home, at no cost.
          </div>
          <div className="cl_iconorange_boxes">
            <div className="cl_iconorange_box cl_iconbox_cam">
              <div className="cl_ib_smalltext">
                One-on-One Telehealth Evaluation
              </div>
              <div className="cl_ib_smalltext cl_ib_smalltext_gray">
                Meet with a licensed physical therapist from the comfort of
                home.
              </div>
            </div>
            <div className="cl_iconorange_box cl_iconbox_check">
              <div className="cl_ib_smalltext">Personalized Recovery Plan</div>
              <div className="cl_ib_smalltext cl_ib_smalltext_gray">
                Get a care plan tailored to your pain, movement, and goals.
              </div>
            </div>
            <div className="cl_iconorange_box cl_iconbox_time">
              <div className="cl_ib_smalltext">Flexible Scheduling</div>
              <div className="cl_ib_smalltext cl_ib_smalltext_gray">
                Do your sessions whenever it fits your day—no appointments
                needed.
              </div>
            </div>
            <div className="cl_iconorange_box cl_iconbox_eye">
              <div className="cl_ib_smalltext">AI-Powered Tracking</div>
              <div className="cl_ib_smalltext cl_ib_smalltext_gray">
                Our technology tracks your form in real time and guides your
                progress.
              </div>
            </div>
            <div className="cl_iconorange_box cl_iconbox_ex">
              <div className="cl_ib_smalltext">
                Engaging, Motivational Exercises
              </div>
              <div className="cl_ib_smalltext cl_ib_smalltext_gray">
                Each session is designed to be clear, rewarding, and easy to
                follow.
              </div>
            </div>
            <div className="cl_iconorange_box cl_iconbox_div">
              <div className="cl_ib_smalltext">Dedicated Care Team</div>
              <div className="cl_ib_smalltext cl_ib_smalltext_gray">
                Your team monitors your progress and steps in when support is
                needed.
              </div>
            </div>
            <div className="cl_iconorange_box cl_iconbox_rew">
              <div className="cl_ib_smalltext">Weekly Gift Card Rewards</div>
              <div className="cl_ib_smalltext cl_ib_smalltext_gray">
                Hit your goals and earn rewards—feel better and get rewarded for
                it.
              </div>
            </div>
            <div>&nbsp;</div>
            <div>
              <div
                className="cl_button_join"
                onClick={() => {
                  setIsPopupOpen(true);
                }}
              >
                Start Your Recovery—For Free
              </div>
            </div>
          </div>
        </div>
        {/* --- */}
        <div className="cl_simple_block cl_simple_block_pt0">
          <div className="cl_round_block_dgreen">
            <div className="cl_50image">&nbsp;</div>
            <div className="cl_50green">
              <div className="cl_ib_semitext">
                Meet Your Weekly Goals
                <br />
                and Earn a Gift Card!
              </div>
              <div
                className="cl_button_join"
                onClick={() => {
                  setIsPopupOpen(true);
                }}
              >
                Start Earning Your Rewards
              </div>
            </div>
          </div>
        </div>
        {/* --- */}
        <div class="cl_round_block cl_round_block_orange">
          <div className="cl_image_block">
            <div className="cl_ib_text">
              <div className="cl_ib_semilargetext">
                Your Dedicated Care Team
              </div>
              <div className="cl_ib_smalltext">
                Work with a licensed physical therapist, a PT assistant, and a
                wellness coach—all focused on helping you recover, stay
                motivated, and feel your best.
              </div>
            </div>
            <div className="cl_ib_image">
              <div className="cl_ib_img_virdio_laptoex">&nbsp;</div>
            </div>
          </div>
        </div>
        {/* --- */}
        <div class="cl_round_block">
          <div className="cl_image_block">
            <div className="cl_ib_image">
              <div className="cl_ib_img_virdio_union">&nbsp;</div>
            </div>
            <div className="cl_ib_text cl_ib_text_right">
              <div className="cl_ib_semilargetext">
                Help Your Family Feel Better Too—at No Cost
              </div>
              <div className="cl_ib_smalltext cl_ib_smalltext_gray">
                Your spouse, partner, and eligible dependents* may be able to
                join Virdio Health. Share the link and support each other on the
                path to less pain and better movement.
                <br />
                *Eligibility varies by client group.
              </div>
              <div className="cl_button_join">
                Share This Link with Your Dependent
              </div>
            </div>
          </div>
        </div>
        {/* --- */}
        <div class="cl_round_block cl_round_block_green0">
          <div className="cl_ib_semilargetext">
            See How Virdio Health Compares
            <div className="cl_button_pink">No copays. No cost to you</div>
          </div>
          <div className="cl_round_block_white cl_mt40 cl_overfauto">
            <div className="cl_ib_semitext">Virdio Health vs In-person PT</div>
            <table className="cl_table">
              <thead>
                <tr>
                  <td>Service</td>
                  <td>Virdio Health</td>
                  <td>In-person PT</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Physical Therapy Assessments and Treatments</td>
                  <td>$0</td>
                  <td>$150+</td>
                </tr>
                <tr>
                  <td>Board Certified Physical Therapist</td>
                  <td>
                    <div className="cl_icon_check"></div>
                  </td>
                  <td>
                    <div className="cl_icon_check"></div>
                  </td>
                </tr>
                <tr>
                  <td>24/7 Access to Health Coach and Support Team</td>
                  <td>
                    <div className="cl_icon_check"></div>
                  </td>
                  <td>
                    <div className="cl_icon_checkno"></div>
                  </td>
                </tr>
                <tr>
                  <td>App-Based On-Demand Healthcare</td>
                  <td>
                    <div className="cl_icon_check"></div>
                  </td>
                  <td>
                    <div className="cl_icon_checkno"></div>
                  </td>
                </tr>
                <tr>
                  <td>No Medical Referral Required</td>
                  <td>
                    <div className="cl_icon_check"></div>
                  </td>
                  <td>
                    <div className="cl_icon_checkno"></div>
                  </td>
                </tr>
                <tr>
                  <td>Appointments Within 24 Hours</td>
                  <td>
                    <div className="cl_icon_check"></div>
                  </td>
                  <td>
                    <div className="cl_icon_checkno"></div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              className="cl_button_join"
              onClick={() => {
                setIsPopupOpen(true);
              }}
            >
              Choose Virdio Health Today
            </div>
          </div>
        </div>

        {/* --- */}
        <div className="cl_simple_block">
          <div className="cl_ib_semilargetext">
            Targeted Relief for Common Pain Areas
          </div>
          <div className="cl_ib_smalltext">
            Virdio Health focuses on the most common sources of joint and muscle
            pain—helping you feel better where it matters most.
          </div>
          <div className="cl_body_hover">
            <div className="cl_body_parts">
              <div>
                <div
                  className={"cl_bp" + (cbph === 2 ? " cl_bp_hover" : "")}
                  onMouseEnter={() => {
                    setHoverBP(2);
                  }}
                  onMouseLeave={() => {
                    setHoverBP(0);
                  }}
                >
                  <div>1</div>Shoulders
                </div>
              </div>
              <div>
                <div
                  className={"cl_bp" + (cbph === 3 ? " cl_bp_hover" : "")}
                  onMouseEnter={() => {
                    setHoverBP(3);
                  }}
                  onMouseLeave={() => {
                    setHoverBP(0);
                  }}
                >
                  <div>2</div>Lower Back
                </div>
              </div>
              <div>
                <div
                  className={"cl_bp" + (cbph === 4 ? " cl_bp_hover" : "")}
                  onMouseEnter={() => {
                    setHoverBP(4);
                  }}
                  onMouseLeave={() => {
                    setHoverBP(0);
                  }}
                >
                  <div>3</div>Hips
                </div>
              </div>
              <div>
                <div
                  className={"cl_bp" + (cbph === 5 ? " cl_bp_hover" : "")}
                  onMouseEnter={() => {
                    setHoverBP(5);
                  }}
                  onMouseLeave={() => {
                    setHoverBP(0);
                  }}
                >
                  <div>4</div>Thighs
                </div>
              </div>
              <div>
                <div
                  className={"cl_bp" + (cbph === 8 ? " cl_bp_hover" : "")}
                  onMouseEnter={() => {
                    setHoverBP(8);
                  }}
                  onMouseLeave={() => {
                    setHoverBP(0);
                  }}
                >
                  <div>5</div>Knees
                </div>
              </div>
            </div>
            <div className="cl_body_middle">
              <div
                className={"cl_bm_2" + (cbph === 2 ? " cl_bp_hover" : "")}
                onMouseEnter={() => {
                  setHoverBP(2);
                }}
                onMouseLeave={() => {
                  setHoverBP(0);
                }}
              >
                1
              </div>
              <div
                className={"cl_bm_3" + (cbph === 3 ? " cl_bp_hover" : "")}
                onMouseEnter={() => {
                  setHoverBP(3);
                }}
                onMouseLeave={() => {
                  setHoverBP(0);
                }}
              >
                2
              </div>
              <div
                className={"cl_bm_4" + (cbph === 4 ? " cl_bp_hover" : "")}
                onMouseEnter={() => {
                  setHoverBP(4);
                }}
                onMouseLeave={() => {
                  setHoverBP(0);
                }}
              >
                3
              </div>
              <div
                className={"cl_bm_5" + (cbph === 5 ? " cl_bp_hover" : "")}
                onMouseEnter={() => {
                  setHoverBP(5);
                }}
                onMouseLeave={() => {
                  setHoverBP(0);
                }}
              >
                4
              </div>
              <div
                className={"cl_bm_8" + (cbph === 8 ? " cl_bp_hover" : "")}
                onMouseEnter={() => {
                  setHoverBP(8);
                }}
                onMouseLeave={() => {
                  setHoverBP(0);
                }}
              >
                5
              </div>
              <p className="middleText">More areas coming soon</p>
            </div>
            <div className="cl_body_parts cl_body_parts2">
              
            </div>
          </div>
        </div>
        {/* --- */}
        <div class="cl_round_block cl_round_block_green2">
          <div className="cl_image_block">
            <div className="cl_ib_image">
              <div className="cl_ib_img_virdio_laptoptwoex">&nbsp;</div>
            </div>
            <div className="cl_ib_text cl_ib_text_right">
              <div className="cl_ib_semilargetext">
                Feel Better—Starting Today
              </div>
              <div className="cl_ib_smalltext">
                Your personalized, at-home physical therapy plan is just a few
                clicks away. No cost. No referral. No waiting.
              </div>
              <div
                className="cl_button_join"
                onClick={() => {
                  setIsPopupOpen(true);
                }}
              >
                Start Your Recovery Now
              </div>
            </div>
          </div>
        </div>

        {/* --- */}
        <div className="cl_simple_block">
          <div className="cl_ib_semilargetext">
            See What People Are Saying About Virdio Health
          </div>
          <div className="cl_ib_smalltext">
            Real patients. Real results. Here's how Virdio Health is helping
            people move better and feel better—at home.
          </div>

          <div className="cl_round_block_orange_small cl_mt40">
            <div className="cl_quotes">&nbsp;</div>
            <div className="cl_testimonial">
              After working with the easy-to-use and engaging Virdio Health app
              for 2 weeks, I no longer experience pain in my back while golfing,
              standing for long periods, or going through my daily tasks. The
              exercises are easy to follow and effective. I recommend the App
              and program to anyone who wants to treat and eliminate back pain.
            </div>
            <div className="cl_test_member">
              Joe
              <div>Virdio Health Member</div>
            </div>
          </div>
        </div>

        {/* --- */}
        <div class="cl_round_block cl_round_block_green0">
          <div className="cl_image_block">
            <div className="cl_ib_image">
              <div className="cl_ib_img_virdio_union2">&nbsp;</div>
            </div>
            <div className="cl_ib_text cl_ib_text_right">
              <div className="cl_ib_semilargetext">
                Proven to Deliver Real Results
              </div>
              <div className="cl_ib_smalltext">
                In our clinical pilot, patients saw major pain relief in just a
                few weeks—with no clinic visits or special equipment.
                <br />
                <br />
                Patients using Virdio Health reduced their pain by 75% in just
                32 days, starting with an average pain score of 7.7 and ending
                near 2.
                <br />
                <br />
                Even better? 74% completed their full recovery plan—a rare feat
                in physical therapy.
              </div>
              <br />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                <div className="cl_ib_percent">
                  <div>75%</div>
                  Average pain reduction in 32 days
                </div>
                <div className="cl_ib_percent">
                  <div>74%</div>
                  Completed their full recovery plan
                </div>
              </div>
              <p>Source: <a href="https://virdiohealth.com/documents/clinical-pilot-summary.pdf" style={{color: "#166273"}}>Virdio Health Clinical Pilot Summary</a></p>
              <div
                className="cl_button_join"
                onClick={() => {
                  setIsPopupOpen(true);
                }}
              >
                Start Your Recovery Now, For Free
              </div>
            </div>
          </div>
        </div>

        {/* --- */}
        <div className="cl_simple_block">
          <div className="cl_round_block_dpurple">
            <div className="cl_50purple">
              <div className="cl_ib_semitext_white">
                Live Life with Less Pain—Starting Today
              </div>
              <div className="cl_ib_smalltext_white">
                Join Virdio Health and take the first step toward feeling
                better—at home, on your terms, and at no cost.
              </div>
              <div
                className="cl_button_join_white"
                onClick={() => {
                  setIsPopupOpen(true);
                }}
              >
                Start Your Recovery Now, For Free
              </div>
            </div>
            <div className="cl_50image2">&nbsp;</div>
          </div>
        </div>
        {/* --- */}

        <div className="cl_simple_block cl_simple_block_pt0">
          <div className="cl_mw550">
            <div className="ptb10">Disclaimer</div>
            <div className="cl_ib_smalltext_gray2">
              * You must be 18 years of age or older to use Virdio Health’s
              virtual physical therapy services. By accessing and using our
              services, you confirm that you meet this age requirement.
			  <br />
			  <br />
			  * Virdio Health utilizes computer vision technology to track your movements and monitor your progress, all without recording any video. 
            </div>
          </div>
        </div>
      </div>
      <div className="cl_sline"></div>
      <div className="cl_footer">
        <div className="cl_foot50">
          <div className="cl_footer_logo">&nbsp;</div>
        </div>
        <div className="cl_foot50">
          <div className="cl_footer_item cl_footer_item_email">
            support@virdio.com
          </div>
          <div className="cl_footer_item cl_footer_item_address">
            3228 Nebraska Ave., Santa Monica, CA 90404
          </div>
        </div>

        <div className="cl_foot50 cl_footer_itemgray">
          &copy; 2025 Virdio, Inc. All Rights Reserved
        </div>
        <div className="cl_foot50 cl_footer_itemgray">
          <a
            href="https://www.virdiohealth.com/privacy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
          <a
            href="https://www.virdiohealth.com/terms"
            target="_blank"
            rel="noreferrer"
          >
            Terms and Conditions
          </a>
          <a
            href="https://www.virdiohealth.com/hipaa-notice"
            target="_blank"
            rel="noreferrer"
          >
            HIPAA Notice
          </a>
          <a
            href="https://www.virdiohealth.com/virdio-health-consent-to-telehealth-services"
            target="_blank"
            rel="noreferrer"
          >
            Telehealth Consent Terms
          </a>
        </div>
      </div>

      {isPopupOpen === true && (
        <div className="cl_popup">
          <div className="cl_popup_inner">
            <div
              className="cl_closep"
              onClick={() => {
                setIsPopupOpen(false);
              }}
            >
              &times;
            </div>
            <div className="cl_popuptext">
              This account isn’t active for sign-up just yet. Once the webpage has been reviewed and approved, the sign-up links will be activated.<br /><br />Thank you for your patience!
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Companylanding;
